import React from "react";
import { Route, Routes } from "react-router-dom";
import CardBlacklist from "./CardBlacklist";
import CardBlacklistLogs from "./CardBlacklistLogs";
import AuditLogs from "./AuditLogs";
import Profile from "./Profile";

const SuperAdminPage = () => {
  return (
    <div className="flexRow full p-0 m-0">
      <div className="full-flex flexCol width100 p-0 m-0">
        <Routes>
          <Route path="cardBlacklistAuditLogs" element={<CardBlacklistLogs />} />
          <Route path="cardBlacklist" element={<CardBlacklist />} />
          <Route path="auditLogs" element={<AuditLogs />} />
          <Route path="profile" element={<Profile />} />
        </Routes>
      </div>
    </div>
  );
};

export default SuperAdminPage;
